// src/components/Library.js
import axios from "axios";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

const Library = ({ language }) => {
  const [searchQuery, setSearchQuery] = useState("");
  const [libraryCategories, setLibraryCategories] = useState([]);
  const navigate = useNavigate();
  const [publications, setPublications] = useState([]);

  const featuredBooks = [
    {
      title: {
        en: "Modern Training Techniques",
        ar: "تقنيات التدريب الحديثة",
      },
      author: { en: "Dr. Mohammed Ali", ar: "د. محمد علي" },
      year: "2023",
    },
    {
      title: {
        en: "Dual Training Methodology",
        ar: "منهجية التدريب المزدوج",
      },
      author: { en: "Prof. Sarah Johnson", ar: "أ. سارة جونسون" },
      year: "2022",
    },
    {
      title: {
        en: "Employee Development Strategies",
        ar: "استراتيجيات تطوير الموظفين",
      },
      author: { en: "Dr. Ahmed Hassan", ar: "د. أحمد حسن" },
      year: "2023",
    },
  ];

  useEffect(() => {
    axios
      .get(
        process.env.REACT_APP_BASE_URL +
          "library-category/get-all-library-category"
      )
      .then((res) => setLibraryCategories(res.data.data));

    axios
      .get(process.env.REACT_APP_BASE_URL + "publication/get-all-publications")
      .then((res) => setPublications(res.data.data));
  }, []);

  const displayedCategories = libraryCategories.slice(0, 4);

  const handleShowMore = () => {
    navigate("/library");
  };

  const handleCategoryClick = (category) => {
    // Navigate to category details page or filter library page
    navigate(`/books?category=${category.id}`);
  };

  return (
    <section id="library" className="py-16 bg-white">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-green-900 mb-4">
            {language === "ar" ? "مكتبة الاكاديمية" : "Academy Library"}
          </h2>
          <div className="w-24 h-1 bg-green-600 mx-auto"></div>
          <p className="text-gray-600 max-w-2xl mx-auto mt-4">
            {language === "ar"
              ? "مجموعة من المصادر التي تضم عددا من الكتب والمطبوعات والمواد التدريبية التي تغطي موضوعات مختلفة والمقسمة ال فئات"
              : "A collection of resources including a number of books, publications, and training materials covering various topics and divided into categories."}
          </p>
        </div>

        {/* Search Bar */}
        <div className="max-w-2xl mx-auto mb-12">
          <div className="relative">
            <input
              type="text"
              placeholder={
                language === "ar"
                  ? "ابحث في المكتبة..."
                  : "Search the library..."
              }
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              className="w-full px-6 py-4 border border-green-300 rounded-2xl focus:outline-none focus:ring-2 focus:ring-green-500 focus:border-transparent"
            />
            <button className="absolute right-3 top-1/2 transform -translate-y-1/2 bg-green-600 text-white p-2 rounded-lg hover:bg-green-700 transition-colors">
              <svg
                className="w-5 h-5"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
                />
              </svg>
            </button>
          </div>
        </div>

        {/* Library Categories */}
        <div className="mb-16">
          {/* <h3 className="text-2xl font-bold text-green-900 mb-8 text-center">
            {language === "ar" ? "فئات المكتبة" : "Library Categories"}
          </h3> */}
          <div className="grid md:grid-cols-2 lg:grid-cols-2 xl:grid-cols-4 gap-6">
            {displayedCategories.map((category, index) => (
              <div
                key={index}
                className="bg-green-50 rounded-xl p-6 border-l-4 border-green-600 hover:shadow-lg transition-all duration-300 transform hover:-translate-y-1"
              >
                <div className="flex items-center mb-4">
                  <span className="text-3xl mr-4 rtl:mr-0 rtl:ml-4">
                    {category.icon || "📚"}
                  </span>
                  <div>
                    <h4 className="font-bold text-green-900 text-lg">
                      {language === "ar" ? category.title_ar : category.title}
                    </h4>
                    <p className="text-green-700">
                      {category.bookCount}{" "}
                      {language === "ar" ? "عنصر" : "items"}
                    </p>
                  </div>
                </div>
                <button
                  onClick={() => handleCategoryClick(category)}
                  className="w-full mt-2 bg-green-600 text-white py-2 rounded-lg font-semibold hover:bg-green-700 transition-colors"
                >
                  {language === "ar" ? "استعرض" : "Browse"} →
                </button>
              </div>
            ))}
          </div>

          {/* Show More Button */}
          {libraryCategories.length > 4 && (
            <div className="text-center mt-8">
              <button
                onClick={handleShowMore}
                className="bg-green-600 hover:bg-green-700 text-white font-bold py-3 px-8 rounded-lg transition-all duration-300 transform hover:scale-105 shadow-lg"
              >
                {language === "ar" ? "عرض جميع الفئات" : "View All Categories"}
              </button>
            </div>
          )}
        </div>

        {/* Featured Books */}
        <div className="bg-gradient-to-r from-green-800 to-green-900 rounded-2xl p-8 text-white">
          <h3 className="text-2xl font-bold mb-8 text-center">
            {language === "ar"
              ? "إصدارات تهمك"
              : "Publications that might interest you"}
          </h3>
          <div className="grid md:grid-cols-2 gap-6">
            {publications.map((item, index) => (
              <div
                key={index}
                className="bg-green-700 bg-opacity-50 backdrop-blur-sm rounded-xl p-6 hover:bg-opacity-70 transition-all duration-300"
              >
                <h4 className="font-bold text-lg mb-2">
                  {language === "ar" ? item.title_ar : item.title}
                </h4>
                <p className="text-green-200 mb-1">
                  {language === "ar" ? "المؤلف:" : "Author:"}{" "}
                  {language === "ar" ? item.author_ar : item.author}
                </p>
                <p className="text-green-200 mb-4">
                  {language === "ar" ? "السنة:" : "Year:"} {item.year}
                </p>
                <a
                  href={process.env.REACT_APP_BASE_URL + item.file}
                  target="_blank"
                  download
                  className="bg-white text-green-800 px-4 py-2 rounded-lg font-semibold hover:bg-green-100 transition-colors w-full"
                >
                  {language === "ar" ? "تحميل" : "Download"} ↓
                </a>
              </div>
            ))}
          </div>
        </div>

        {/* Library Stats */}
        <div className="mt-12 text-center">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-6 max-w-2xl mx-auto">
            {[
              { number: "1,200+", label: { en: "Books", ar: "كتاب" } },
              {
                number: "500+",
                label: { en: "Research Papers", ar: "بحث علمي" },
              },
              {
                number: "300+",
                label: { en: "Training Manuals", ar: "دليل تدريبي" },
              },
              {
                number: "24/7",
                label: { en: "Digital Access", ar: "وصول رقمي" },
              },
            ].map((stat, index) => (
              <div key={index} className="text-center">
                <div className="text-2xl font-bold text-green-800 mb-1">
                  {stat.number}
                </div>
                <div className="text-green-700 text-sm">
                  {language === "ar" ? stat.label.ar : stat.label.en}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Library;
